import PropTypes from "prop-types";

const InstagramIcon = ({ color = "white", bgColor = "#7B9E7E" }) => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.258301"
        width="29.9111"
        height="29.9111"
        rx="4.78577"
        fill={bgColor}
      />
      <path
        d="M20.2983 4.79077H9.54929C6.77952 4.79077 4.5332 7.03709 4.5332 9.80686V20.5559C4.5332 23.3257 6.77952 25.572 9.54929 25.572H20.2983C23.0681 25.572 25.3144 23.3257 25.3144 20.5559V9.80686C25.3144 7.03709 23.0681 4.79077 20.2983 4.79077ZM23.5237 20.198C23.5237 22.1761 21.9185 23.7813 19.9404 23.7813H9.90822C7.9301 23.7813 6.32487 22.1761 6.32487 20.198V10.1658C6.32487 8.18767 7.9301 6.58244 9.90822 6.58244H19.9404C21.9185 6.58244 23.5237 8.18767 23.5237 10.1658V20.198Z"
        fill={color}
      />
      <path
        d="M14.9326 9.80688C11.9664 9.80688 9.55859 12.2147 9.55859 15.1809C9.55859 18.1471 11.9664 20.5549 14.9326 20.5549C17.8988 20.5549 20.3066 18.1471 20.3066 15.1809C20.3066 12.2147 17.8988 9.80688 14.9326 9.80688ZM14.9326 18.7643C12.9585 18.7643 11.3493 17.155 11.3493 15.1809C11.3493 13.2068 12.9585 11.5976 14.9326 11.5976C16.9067 11.5976 18.516 13.2068 18.516 15.1809C18.516 17.155 16.9067 18.7643 14.9326 18.7643Z"
        fill={color}
      />
      <path
        d="M20.6666 10.5236C20.0744 10.5236 19.5918 10.0411 19.5918 9.44883C19.5918 8.85659 20.0744 8.37402 20.6666 8.37402C21.2588 8.37402 21.7414 8.85659 21.7414 9.44883C21.7414 10.0411 21.2588 10.5236 20.6666 10.5236Z"
        fill={color}
      />
    </svg>
  );
};

const { string } = PropTypes;

InstagramIcon.propTypes = {
  color: string,
  bgColor: string
};

export default InstagramIcon;
